import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import { typedFetch } from '../typedFetch';
import { Departments } from './Departments';
import { Login } from './Login';
import { Schedule } from './Schedule';
import { Schedules } from './Schedules';
import { Ticket } from './Ticket';
import { Tickets } from './Tickets';
import { User } from './User';
import { Users } from './Users';
import './header.scss';
const modules = {
    tickets: Tickets,
    ticket: Ticket,
    schedules: Schedules,
    schedule: Schedule,
    departments: Departments,
    users: Users,
    user: User,
    login: Login,
};
const pathname = window.location.pathname.slice(1);
const userMatch = window.location.pathname.match(/^\/users\/([^/]+)$/);
const ticketMatch = window.location.pathname.match(/^\/tickets\/\d+$/);
const scheduleMatch = window.location.pathname.match(/^\/schedules\/(?:\d+|new)$/);
const moduleName = userMatch ? 'user' : ticketMatch ? 'ticket' : scheduleMatch ? 'schedule' : pathname;
const logout = () => {
    localStorage.removeItem('token');
    window.location.href = '/';
};
export const Core = ({ appendToErrorLog, }) => {
    const [loggedInUser, setLoggedInUser] = useState();
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) {
            setLoading(false);
            return;
        }
        typedFetch('get-user')
            .then((result) => {
            if (result.success) {
                setLoggedInUser(result.user);
            }
            else {
                appendToErrorLog(`Login failed: ${result.reason}`);
                localStorage.removeItem('token');
            }
        })
            .catch((error) => {
            appendToErrorLog(`Unexpected error while verifying stored token: ${String(error['message'])}`);
        })
            .finally(() => {
            setLoading(false);
        });
    }, [appendToErrorLog]);
    if (moduleName !== 'tickets' && moduleName !== 'ticket' && moduleName !== 'schedules' && moduleName !== 'schedule' && moduleName !== 'departments' && moduleName !== 'users' && moduleName !== 'user' && moduleName !== 'login' && moduleName !== '') {
        return '404';
    }
    return (_jsxs(_Fragment, { children: [_jsxs("header", { className: "core-header", children: [_jsxs("nav", { children: [_jsx("a", { href: "/tickets", className: pathname === 'tickets' ? 'active' : '', children: "Tickets" }), _jsx("a", { href: "/schedules", className: pathname === 'schedules' ? 'active' : '', children: "Schedules" }), _jsx("a", { href: "/departments", className: pathname === 'departments' ? 'active' : '', children: "Departments" }), _jsx("a", { href: "/users", className: pathname.startsWith('users') ? 'active' : '', children: "Users" })] }), _jsx("div", { className: "profile", children: loading
                            ? 'Logging in...'
                            : loggedInUser
                                ? (_jsxs(_Fragment, { children: [_jsx("a", { href: `/users/${loggedInUser.email.match(/^[^@]+/)[0]}`, children: loggedInUser.name }), _jsx("button", { onClick: logout, children: "Log out" })] }))
                                : _jsx("a", { href: "/login", children: "Login" }) })] }), loading
                ? 'Logging in...'
                : moduleName === ''
                    ? null
                    : React.createElement(modules[moduleName], { appendToErrorLog, loggedInUser })] }));
};
